var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.question.label))]),_vm._v(" "),_c('RichContent',{staticClass:"field-value",attrs:{"content":_vm.formattedValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }